var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPayDeko(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 22,
    viewBox: "0 0 98 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#122E34",
    d: "M9.218 18.323H3.836a.402.402 0 01-.4-.402V4.079c0-.222.179-.402.4-.402H9.33c4.063 0 7.361 3.347 7.3 7.437-.062 4.018-3.405 7.21-7.41 7.21zM9.33.23H.535A.536.536 0 000 .767v20.466c0 .296.24.537.535.537h8.66c5.919 0 10.825-4.75 10.869-10.688C20.108 5.096 15.285.23 9.329.23zM87.035 0C80.98 0 76.071 4.925 76.071 11s4.909 11 10.964 11C93.091 22 98 17.075 98 11S93.09 0 87.035 0zm0 3.402c4.176 0 7.573 3.409 7.573 7.598 0 4.19-3.397 7.597-7.573 7.597-4.175 0-7.573-3.408-7.573-7.597 0-4.19 3.398-7.598 7.573-7.598zM56.133 21.77h-2.366a.536.536 0 01-.535-.537V.767c0-.297.24-.537.535-.537h2.366c.295 0 .535.24.535.537v20.466c0 .296-.24.537-.535.537"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3636F",
    d: "M46.06 3.14V.767a.536.536 0 00-.535-.537H26.522a.536.536 0 00-.535.537V3.14c0 .296.24.536.535.536h19.003c.296 0 .535-.24.535-.536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB9D3F",
    d: "M25.987 18.86v2.373c0 .296.24.537.535.537h19.003c.296 0 .535-.24.535-.537V18.86a.536.536 0 00-.535-.537H26.522a.536.536 0 00-.535.537"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24B095",
    d: "M46.06 12.187V9.813a.536.536 0 00-.535-.536H26.522a.536.536 0 00-.535.536v2.374c0 .296.24.536.535.536h19.003c.296 0 .535-.24.535-.536"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#122E34",
    d: "M63.383 10.81L73.473.688a.268.268 0 00-.19-.458h-3.935a.667.667 0 00-.473.197l-9.783 9.814a1.075 1.075 0 000 1.518l9.783 9.814a.668.668 0 00.473.197h3.935a.268.268 0 00.19-.458L63.382 11.19a.269.269 0 010-.38"
  }))));
}

export default SvgPayDeko;